var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMercury(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3 6.42461L18.45 4.54961L16.575 3.69961L18.45 2.84961L19.3 0.974609L20.15 2.84961L22.025 3.69961L20.15 4.54961L19.3 6.42461ZM7.25002 6.42461L6.40002 4.54961L4.52502 3.69961L6.40002 2.84961L7.25002 0.974609L8.10002 2.84961L9.97502 3.69961L8.10002 4.54961L7.25002 6.42461ZM19.3 18.4746L18.45 16.5996L16.575 15.7496L18.45 14.8996L19.3 13.0246L20.15 14.8996L22.025 15.7496L20.15 16.5996L19.3 18.4746ZM3.67502 21.6996L1.30002 19.3246C1.11668 19.1413 1.01668 18.9288 1.00002 18.6871C0.983349 18.4454 1.08335 18.2163 1.30002 17.9996L12.55 6.74961C12.75 6.54961 12.9917 6.44961 13.275 6.44961C13.5583 6.44961 13.8 6.54961 14 6.74961L16.25 8.99961C16.45 9.19961 16.55 9.44128 16.55 9.72461C16.55 10.0079 16.45 10.2496 16.25 10.4496L5.00002 21.6996C4.80002 21.8996 4.57918 21.9996 4.33752 21.9996C4.09585 21.9996 3.87502 21.8996 3.67502 21.6996ZM4.25002 20.2746L12.075 12.4496L10.525 10.8996L2.70002 18.7246L4.25002 20.2746Z",
    fill: "url(#paint0_linear_2780_1601)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2780_1601",
    x1: 4.2814,
    y1: 21.335,
    x2: 25.8597,
    y2: 6.58514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9116F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3199FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercury);
export default __webpack_public_path__ + "static/media/mercury.9f621c97f48a04680d3f7027f2764225.svg";
export { ForwardRef as ReactComponent };